<template>
  <div class="vertical-tabs w-full">
    <ul
      class="tab-links flex h-full w-full list-none border-b-4 border-r-2 border-gray-100 border-b-gray-300"
    >
      <li
        v-for="(tab, index) in tabs"
        :key="index"
        :class="{
          'border-b-4 border-l border-t border-b-green-600 bg-white text-green-600 shadow':
            tabActive === tab.name,
        }"
      >
        <a
          class="block cursor-pointer px-4 py-3"
          @click="setActiveTab(tab.name)"
        >
          {{ tab.name }}
        </a>
      </li>
    </ul>

    <div class="tab-content p-6">
      <slot :tab="tabActive" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerticalTabs',

  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
  },

  emits: ['tabChanged'],

  data() {
    return {
      tabActive: this.activeTab,
    }
  },

  watch: {
    activeTab: {
      handler(newTab) {
        this.$emit('tabChanged', {
          tab: newTab,
        })
      },
      immediate: true,
    },
  },

  methods: {
    setActiveTab(tab) {
      this.tabActive = tab
    },
  },
}
</script>
